import React, { useEffect, useState } from "react";
import AllItemsDialog from "../../../Component/ContentDialog/ContentDialog";
import "./style.scss";
import { scrollTop } from "Utils/ScrollTop";
import { Link, useLocation } from "react-router-dom";
import CommonService from "Component/Modules/API/Services/Common.service";
import { PopupProps } from "../types/type";
import Skeleton from "Component/Skeleton/Skeleton";
import useDidMountEffect from "Component/UseDisMountEffect/Function";
import withWorks from "../HOC/withWorks";

function ConceptArt() {
  const [workList, setWorkList] = useState<PopupProps[]>([]);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    CommonService.GetWorkAll([3])
      .then((response:any) => {
        if (response) {
          const data = response.filter((item :any)=> item.sub_category ==='Concept Art')
          setWorkList(data);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);
  function SkeletonContentsList(size: number) {
    var list = [];
    for (var i = 0; i < size; i++) {
      list.push(
        <div key={i}>
          <Skeleton type="twoElements" height={514} variant="rounded"></Skeleton>
        </div>
      );
    }
    return list;
  }
  useDidMountEffect(() => {
    setLoading(false);
  }, [workList]);
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  return (
    <>
      {workList.map((item, index) => (
        <React.Fragment key={index}>
          {location.hash === "#" + item.id && (
            <>
              <AllItemsDialog data={item} />
              <p className="titleCategory">Concept Art</p>
            </>
          )}
        </React.Fragment>
      ))}

      <div className="conceptart" style={{ width: "100%" }}>
        {loading === false
          ? workList.map((item, index) => (
              <React.Fragment key={index}>
                <Link
                  to={{ search: "conceptart", hash: String(item.id) }}
                  onClick={() => scrollTop()}
                >
                  <div className="works-item">
                    <img src={item.sub_thumbnail} alt="" />
                    <div className="card-info">
                      <div className="card-title">
                        <span style={{ textTransform: "uppercase" }}>
                          Concept art
                        </span>
                      </div>
                      <div
                        className="card-content"
                        style={{ textAlign: "center" }}
                      >
                        <p>{item.name.en}</p>
                        <p>{item.year}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </React.Fragment>
            ))
          : SkeletonContentsList(8)}
      </div>
    </>
  );
}

export default withWorks(ConceptArt);
